import { Stack } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { DataTitle } from '../../DataTitle';
import { useAppSelector, useIsDesktop } from 'Hooks';
import {
  IAbroadAddress,
  IILHomeAddress,
  IILHomeAddressWithoutTownId,
} from '..';
import { useEffect, useState } from 'react';

interface IHomeAddress {
  address: IILHomeAddress | null;
  abroad?: IAbroadAddress | null;
}

export const HomeAddress = ({ address }: IHomeAddress) => {
  const town = useAppSelector(
    ({ generalOptions: { generalOptions } }) => generalOptions
  )?.cities?.find((city: any) => city.id === address?.townId)?.value;
  const isDesktop = useIsDesktop();

  const [userAddresses, setUserAddresses] =
    useState<IILHomeAddressWithoutTownId>({
      town: null,
      street: null,
      zipCode: null,
    });

  useEffect(() => {
    if (address) {
      const tempUserAddress: IILHomeAddressWithoutTownId = {
        town: town,
        street: address.street,
        zipCode: address.zipCode,
      };
      setUserAddresses(tempUserAddress);
    }
  }, [address, town]);

  const arrayData = Object.values(userAddresses);
  const dataKeys = Object.keys(userAddresses);
  const dict: any =
    Dictionary[DICTIONARY.PersonalDetails].addressInformation.homeAddress;

  return (
    <Stack
      flexWrap={'wrap'}
      direction={'row'}
      gap={isDesktop ? '40px' : '20px 10px'}
    >
      {arrayData?.map((item: any, index: number) => {
        return (
          <Stack width={'136px'} key={index}>
            <DataTitle dataTitle={dict[dataKeys[index]]} data={item} />
          </Stack>
        );
      })}
    </Stack>
  );
};
